import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { LangContext } from "../i18n";
import { SiteProvider, useSite } from "./SiteContext";
import AccessGate from "./AccessGate";
import Header from "./Header";
import Footer from "./Footer";
import Intro from "./Intro";
import Hreflang from "./Hreflang";
import { Toaster } from "./ui/sonner";

const ShellBody = ({ lang }) => {
  const site = useSite();

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  if (!site.ready) return <div className="min-h-screen bg-[#F4F0E8]" />;

  return (
    <LangContext.Provider value={{ lang, t: site.t }}>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:bg-[#C6A46A] focus:px-4 focus:py-2 focus:text-xs focus:uppercase focus:tracking-[0.15em] focus:text-[#171717]"
      >
        {site.t.common.skip}
      </a>
      <Hreflang />
      <AccessGate>
        <Header />
        <main id="main">
          <Outlet />
        </main>
        <Footer />
        <Intro />
      </AccessGate>
      <Toaster theme="dark" position="top-center" />
    </LangContext.Provider>
  );
};

// Shared chrome for one language: CMS data, access gate, header, outlet, footer.
const Shell = ({ lang }) => (
  <SiteProvider lang={lang}>
    <ShellBody lang={lang} />
  </SiteProvider>
);

export default Shell;
